import routerOptions0 from "C:/inetpub/gitlab-runner/navatel.ir-new-website/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  strict: false
}
export default {
...configRouterOptions,
...routerOptions0,
}